import { NgModule } from "@angular/core";
import { SafeHtml } from "../../modules/shared/pipes/safeHtml.pipe";
import { Humanize } from "../../modules/shared/pipes/humanizeText.pipe";
import { SearchPipe } from "../../modules/shared/pipes/searchFilter.pipe";
import { ToDateObj } from "../../modules/shared/pipes/toDateObj.pipe";

@NgModule({
    imports: [
        // dep modules
    ],
    declarations: [SafeHtml, Humanize, SearchPipe, ToDateObj],
    exports: [SafeHtml, Humanize, SearchPipe, ToDateObj]
})
export class SharedModule {}
